module.exports = __webpack_public_path__ + "img/science-side-bg.0908576.png";